import { createSlice } from "@reduxjs/toolkit"

export const vendorProfileListSlice = createSlice({
	name: "vendorProfile_list",
	initialState: {
		vendorProfile: "",
		errors: [],
	},

	reducers: {
        getVendorProfile: (state, action) => {
            // console.log(action.payload);
			state.vendorProfile = action.payload
		},
		getVendorProfileList: (state, action) => {
            
			state.vendorProfile = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getVendorProfile, getVendorProfileList, getErrors} = vendorProfileListSlice.actions

export default vendorProfileListSlice.reducer

